import {
  Code,
  Em,
  Span,
  Stack,
  type StackProps,
  Text,
  type TextProps,
} from "@chakra-ui/react";

type RenderFormElementProps = {
  label: string;
  currentValue?: string | number | boolean | null | undefined;
  previousValue?: string | number | boolean | null | undefined;
  valueProps?: TextProps;
  children?: React.ReactNode;
  caseSensitive?: boolean;
};

export const RenderFormElement = ({
  label,
  currentValue,
  previousValue,
  caseSensitive = false,
  children,
  valueProps,
}: RenderFormElementProps) => {
  const isChanged = previousValue
    ? currentValue &&
      typeof currentValue === "string" &&
      typeof previousValue === "string"
      ? caseSensitive
        ? currentValue !== previousValue
        : currentValue.toLowerCase() !== previousValue.toLowerCase()
      : previousValue !== currentValue
    : false;
  return (
    <>
      {isChanged ? (
        <Text textStyle="fieldContent">
          <Span textStyle="fieldLabel">{label}: </Span>
          {previousValue && (
            <Code colorPalette={"red"} variant={"subtle"}>
              {`${previousValue} ->`}
            </Code>
          )}
          <Code colorPalette={"green"} variant={"subtle"}>
            {`${currentValue}`}
          </Code>
        </Text>
      ) : (
        <Text textStyle="fieldContent">
          <Span textStyle="fieldLabel">{label}: </Span>
          {previousValue ? (
            <Span color={"fg.warning"}>
              <Em>{"No Change"}</Em>
            </Span>
          ) : (
            <Span color={"tertiary.fg"} {...valueProps}>
              {currentValue ? (
                <b> {currentValue} </b>
              ) : (
                <Em color={"fg.warning"}>{"No Value"}</Em>
              )}
            </Span>
          )}
        </Text>
      )}

      {children}
    </>
  );
};

type FormRenderElementsProps = {
  items: RenderFormElementProps[];
  valueProps?: TextProps;
  containerProps?: StackProps;
  [key: string]: any;
};

export const RenderFormElements = ({
  items,
  containerProps,
  ...rest
}: FormRenderElementsProps) => {
  return (
    <Stack direction="column" align="flex-start" gap={2} {...containerProps}>
      {items.map((item, index) => (
        <RenderFormElement key={`${item.label}-${index}`} {...item} {...rest} />
      ))}
    </Stack>
  );
};
